import service from './index';

export const flatten = (arr, formatArr, parent) =>
  arr.reduce((flat, toFlatten) => {
    const paths = [...(parent.paths || []), ...[toFlatten.Name]];
    const ids = [...(parent.ids || []), ...[toFlatten.Id]];

    toFlatten.Nodes = toFlatten.Nodes || [];
    if (toFlatten.Nodes.length <= 0) {
      formatArr.push({
        value: toFlatten.Id,
        label: toFlatten.Name,
        Id: toFlatten.Id,
        Name: toFlatten.Name,
        path: paths.join(' > '),
        ids: ids,
        paths,
        values: ids,
      });
      return formatArr;
    }

    toFlatten.path = paths.join(' > ');
    toFlatten.paths = paths;
    toFlatten.ids = ids;

    return flatten(toFlatten.Nodes, formatArr, toFlatten);
  }, []);

const checkIsClosed = items => {
  return items.reduce((categories, item) => {
    if (item.Nodes) {
      item.Nodes = checkIsClosed(item.Nodes);
    }
    if (!item.isClosed) {
      categories.push(item);
    }
    return categories;
  }, []);
};

export default {
  async getProductCategoriesBySupplier (params) {
    const response = await service.get('/categories/by-supplier', {
      params,
      hideSpinner: true,
    });
    return response;
  },
  async getCategories (options = {}) {
    const response = await service.get('/product-categories', {
      hideSpinner: true,
      hideErrorMessage: true,
    });
    let Categories = response.Categories;
    if (!options.showIsClosed) {
      Categories = checkIsClosed(response.Categories);
    }
    return { Categories };
  },
  async getFlattenCategories (options = {}) {
    const response = await service.get('/product-categories', {
      hideSpinner: true,
      hideErrorMessage: true,
    });
    let Categories = response.Categories;
    if (!options.showIsClosed) {
      Categories = checkIsClosed(response.Categories);
    }
    return flatten(Categories, [], {});
  },
  async getCategoryAttributes (categoryId) {
    const response = await service.get(`/product-categories/${categoryId}/attributes`);
    return response;
  },
  async getCategoryPriceByCategoryId (categoryId) {
    const response = await service.get(`/product-categories/${categoryId}/price`, {
      hideSpinner: true,
      hideErrorMessage: true,
    });
    return response;
  },
};
